var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#B6B8D5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74609 13.1601V11.0481L8.36529 8.96172V11.0609L5.56209 12.0977L8.36529 13.1473V15.2465L2.74609 13.1601Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9905 17.0001H8.94253L12.9617 6.12012H15.0097L10.9905 17.0001Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6257 15.2465V13.1473L18.4417 12.0977L15.6257 11.0609V8.96172L21.2449 11.0481V13.1601L15.6257 15.2465Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDev);
export default __webpack_public_path__ + "static/media/icn-dev.cd2462f68246b45674ec2c9e86faa5ee.svg";
export { ForwardRef as ReactComponent };